import {
  ChangeDetectorRef,
  ComponentFactory,
  ComponentRef,
  Directive, EventEmitter,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {NgxFiltersService} from "../ngx-filters.service";
import {ConditionOperator, Filter, FilterTypes, LogicalOperator} from "../ngx-types";
import {map} from "rxjs/operators";

@Directive({})
export abstract class NgxFilterBase implements OnInit, OnDestroy {
  // public filtersService: FiltersService;
  @ViewChild('containerRefDev1', {read: ViewContainerRef}) containerRefDev1: ViewContainerRef;
  @ViewChild('containerRefDev2', {read: ViewContainerRef}) containerRefDev2: ViewContainerRef;
  public filterService: NgxFiltersService
  private ref: ChangeDetectorRef;
  abstract changeValue: EventEmitter<any>;
  private _injector: Injector;

  protected constructor(injector: Injector) {
    this._injector = injector;
    this.filterService = injector.get(NgxFiltersService);
    // this.ref = injector.get(ChangeDetectorRef);
  }

  componentRef1: ComponentRef<any>;
  componentRef2: ComponentRef<any>;
  abstract Label1: string;
  abstract Label2: string;
  conditionSource: { key: ConditionOperator, label: string, types: FilterTypes[] }[] = [];
  abstract filter: Filter;
  private _isFirst = true;

  get filterTypes() {
    return FilterTypes;
  }

  get conditionOperators() {
    return ConditionOperator;
  }

  get logicalOperators() {
    return LogicalOperator;
  }

  ngOnInit(): void {
  }

  generateComponents(factory: ComponentFactory<any>, options: any, conditions = null): void {
    setTimeout(() => {
        if (this.containerRefDev1) {
          this.containerRefDev1.clear();
          this.componentRef1 = factory.create(this._injector);
          // setTimeout(() => {
          this.componentRef1.instance.label = this.Label1;
          if (this.filter.type == FilterTypes.MultiSelect) {
            this.componentRef1.instance.value = this.filter.values;

          } else {
            this.componentRef1.instance.value = this.filter.value;
          }
          this.componentRef1.instance.filter = this.filter;
          this.componentRef1.instance.filterService = this.filterService;
          this.componentRef1.instance.options = options;

          if (this.componentRef1.instance.conditions) {
            this.componentRef1.instance.conditions = conditions;
          }
          this.componentRef1.instance.valueChange.subscribe(ev => {
            if (conditions) {
              this.filter.conditionOperator = ev;
            } else {
              if (this.filter.type == FilterTypes.MultiSelect) {
                this.filter.values = ev;
              } else {
                this.filter.value = ev;
              }

            }
            this.changeValue.emit(ev);
          });
          this.containerRefDev1.insert(this.componentRef1.hostView);
          // })
        }
        if (this.containerRefDev2) {

          this.containerRefDev2.clear();
          this.componentRef2 = factory.create(this._injector);

          // setTimeout(() => {
          this.componentRef2.instance.label = this.Label2;
          this.componentRef2.instance.value = this.filter.valueTo;
          this.componentRef2.instance.filter = this.filter;
          this.componentRef2.instance.options = options;
          this.componentRef2.instance.filterService = this.filterService;
          this.componentRef2.instance.valueChange.subscribe(ev => {
            this.filter.valueTo = ev;
            this.changeValue.emit(ev);
          });
          this.containerRefDev2.insert(this.componentRef2.hostView);

          // });

        }
      }
    )


  }

  refreshLabels(): void {
    if (this.componentRef1)
      this.componentRef1.instance.label = this.Label1;
    if (this.componentRef2)
      this.componentRef2.instance.label = this.Label2;
  }

  ngOnDestroy()
    :
    void {
    this.componentRef1?.destroy();
    this.componentRef2?.destroy();
  }
}


